import {
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_PAN,
  USER_LOGIN_REFRESH_SUCCESS,
  POSTER_OPEN,
} from "../types/auth";
import { GET_INVESTOR_DETAILS, GET_INVESTOR_DETAILS_SUCCESS } from "../types";

const initialState = {
  token: null,
  showAll: false,
  lastLogin: "",
  posterStatus: 0,
  user_pan: "",
  tran_enable_flag: "",
  auth_token: null,
  beta_user: false,
  test_user: false,
  isCartUser: false,
  userId: "",
  investorData: {
    PAN: "",
    invName: "",
  },
};

const BETA_USERS = [
  "00259099",
  "00126726",
  "00224229",
  "00127708",
  "00000134",
  "00062666",
  "00000018",
  "00139459",
];

export function authReducer(state = initialState, action) {
  switch (action.type) {
    case USER_LOGIN_SUCCESS: {
      const { DtData, Dtinformation, token } = action.body;

      let ARNCode, Login_MailID, Regflag, test_user;

      if (DtData && DtData.length > 0) {
        const [data] = DtData;
        ARNCode = data.ARNCode;
        Login_MailID = data.Login_MailID;
        Regflag = data.Regflag;
        test_user = data.test_user;
      }

      const lastLogin =
        Dtinformation && Dtinformation.length > 0
          ? Dtinformation[0].last_login
          : null;
      const tran_enable_flag =
        DtData && DtData.length > 0 ? DtData[0].tran_enable_flag : null;
      const beta_user =
        DtData && DtData.length > 0 ? !!DtData[0].beta_user : null;
      const isCartUser =
        DtData && DtData.length > 0 ? DtData[0].cart_user === "Y" : null;
      const mobile = DtData && DtData.length > 0 ? DtData[0].mobile : null;

      return {
        ...state,
        nomineeFlag: test_user === "Y",
        npsFlag: true,
        token: ARNCode,
        auth_token: token,
        userId: Login_MailID,
        lastLogin,
        tran_enable_flag,
        Regflag,
        beta_user: !!DtData[0].beta_user,
        test_user: !!DtData[0].test_user,
        isCartUser: DtData[0].cart_user === "N",
        mobile: DtData[0].mobile,
        userLoggedOut: false,
      };
    }

    case POSTER_OPEN: {
      return {
        ...state,
        posterStatus: action.body,
      };
    }
    case USER_LOGIN_REFRESH_SUCCESS: {
      return {
        ...state,
        auth_token: action.body.token,
      };
    }
    case GET_INVESTOR_DETAILS: {
      return {
        ...state,
        investorData: {},
        showAll: false,
        communicationDetails: [],
        bankDetails: [],
        fundList: [],
      };
    }
    case GET_INVESTOR_DETAILS_SUCCESS: {
      const {
        Table14: communicationDetails,
        Table7: bankDetails,
        Table11,
        Table14: fundList,
      } = action.body;
      const [investorData] = Table11;
      return {
        ...state,
        showAll: true,
        investorData,
        communicationDetails,
        bankDetails,
        fundList,
      };
    }
    case USER_LOGOUT: {
      return {
        ...initialState,
        loginPoster: state.loginPoster,
        userLoggedOut: true,
      };
    }
    case USER_PAN: {
      return {
        ...state,
        user_pan: action.body,
      };
    }
    default:
      return state;
  }
}
